export type Card = {
  title: string;
  description: string;
  link: string;
};

export const cards: Card[] = [
  {
    title: 'Anjali Verma',
    description: 'IICL helped me gain confidence in programming. The hands-on training was incredible!',
    link: '#',
  },
  {
    title: 'Rohit Sharma',
    description: 'Great learning environment with friendly instructors. Highly recommend for IT courses.',
    link: '#',
  },
  {
    title: 'Neha Singh',
    description: 'IICL gave me the foundation I needed to land my first job in web development.',
    link: '#',
  },
  {
    title: 'Karan Patel',
    description: 'The practical training approach at IICL made complex topics very easy to grasp.',
    link: '#',
  },
  {
    title: 'Priya Desai',
    description: 'Very supportive teachers and a great curriculum. Loved my journey with IICL.',
    link: '#',
  },
  {
    title: 'Amit Rao',
    description: 'The course structure was well organized, and I got placed right after completing it!',
    link: '#',
  },
];
